import { UserPlus } from 'lucide-react';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Button } from '@/Components/shadcn/button';
import { RHFInput } from '@/Components/shadcn/rhf-input';
import ProcessingState from '@/Models/ProcessingState';
import UIStrings from '@/Utils/UIStrings';
import { useInviteCandidateContext } from '../../Contexts/InviteCandidateContext';
import { Spinner } from '@/Components/shadcn';

function CandidateInputForm(): React.JSX.Element {
    const { processingState } = useInviteCandidateContext();
    const { formState } = useFormContext();

    return (
        <div className="flex flex-row items-start gap-4">
            <RHFInput
                className="basis-1/3"
                name="firstName"
                fieldDataCy="firstName"
                label={UIStrings.FirstNameWithAesterisk}
            />
            <RHFInput
                className="basis-1/3"
                name="lastName"
                fieldDataCy="lastName"
                label={UIStrings.LastNameWithAesterisk}
            />
            <RHFInput className="basis-1/3" name="email" fieldDataCy="email" label={UIStrings.ApplicantEmail} />
            <div className="mt-6.5 flex min-w-40 shrink-0 flex-col">
                <Button
                    type="submit"
                    variant="default"
                    size="default"
                    disabled={processingState === ProcessingState.Processing || formState.isSubmitting}
                    className="gap-2"
                    data-cy="submitAddApplicant"
                >
                    {formState.isSubmitting ? (
                        <Spinner className="size-5 shrink-0" />
                    ) : (
                        <UserPlus className="size-5 shrink-0" />
                    )}
                    {UIStrings.AddApplicant}
                </Button>
            </div>
        </div>
    );
}

export default CandidateInputForm;
